import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

// a table which when expanded shows the contents of an order
// used to show the sumarised bill of all confirmed orders
export default function NestedOrderTable({orders, loadState}) {
  
  if (loadState === 'loading') {
    return (
      <Box sx={{display: 'flex', flexDirection:'column', height: '100%', alignItems: 'start'}}>
        <Box sx={{display: 'flex', flexDirection:'column', width: '100%', alignItems: 'center'}}>
          <CircularProgress />
        </Box>
      </Box>
    )
  }

  
  else if (loadState === 'nothing') {
    return (
    <Box sx={{display: 'flex', flexDirection:'column', height: '100%', alignItems: 'start'}}>
      <Box sx={{display: 'flex', flexDirection:'column', width: '100%', alignItems: 'center', p: 3}}>
        <Typography variant="h5" align='center'>You have not added any items to your order yet.</Typography>
      </Box>
    </Box>
    )
  }

  else if (loadState === 'loaded') {
    return (
      <div>
        {orders.map((order, index) => (
          <Accordion key={order.id} sx={{backgroundColor: "#e6e6e6", 
          '&.Mui-expanded': {
            margin: 0
          }}}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
              sx={{ backgroundColor: "white", fontWeight: "bold"}}
            >
                
              <Typography variant="h7" sx={{ display: "flex", flexDirection: "column" }}>Order {order.id.slice(-3)}
                <Typography variant="caption">Total: ${order.price}</Typography>
              </Typography>
            </AccordionSummary>
            <TableContainer sx={{ maxWidth: '95%', m: 1}}>
              <Table sx={{ minWidth: 200, border: "none", backgroundColor: "#e6e6e6"}} aria-label="simple table">
                <TableBody>
                  {Object.values(order.dishes).map((dish) => (
                    <TableRow
                      key={dish.id}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row" sx={{display: "flex", alignItems: "center", fontWeight: "bold", width: '50%', fontSize: '1rem'}}>
                        <Box><img
                        src={process.env.PUBLIC_URL + '/assets/dish/' + dish.imagePath}
                        alt={"picture of " + dish.name}
                        style={{
                          width: 100,
                          height: 100,
                          marginRight: 10,
                          border: "1px solid",
                          borderRadius: 3
                        }}
                        /></Box>
                        {dish.name}
                      </TableCell>
                      <TableCell align="right" style={{ width: '25%' }}>{dish.quantity}</TableCell>
                      <TableCell align="right" style={{ width: '25%' }}>{"$" + dish.final_price * dish.quantity}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Accordion>
        ))}
      </div>
    );
  }
}